<!-- 柱状图配置 -->
<template>
  <div>
    <el-form-item label="竖展示">
      <el-switch type="textarea"
                   v-model="main.activeOption.category" size="small"></el-switch>
    </el-form-item>
    <el-form-item label="toolTip辅助指标" label-width="120px">
      <el-switch v-model="main.activeOption.assistTip" size="small"></el-switch>
    </el-form-item>
    <el-collapse accordion>
      <el-collapse-item title="柱体设置">
        <el-form-item label="图形宽度">
          <el-slider v-model="main.activeOption.barWidth">
          </el-slider>
        </el-form-item>
        <el-form-item label="圆角">
          <el-slider v-model="main.activeOption.barRadius">
          </el-slider>
        </el-form-item>
        <el-form-item label="最小高度">
          <el-slider v-model="main.activeOption.barMinHeight">
          </el-slider>
        </el-form-item>
        <el-form-item label="柱状图指标数">
          <el-input-number v-model="main.activeOption.barNumber" size="small"></el-input-number>
        </el-form-item>
        <el-form-item label="线图指标数">
          <el-input-number v-model="main.activeOption.lineNumber" size="small"></el-input-number>
        </el-form-item>
        <Color :prop="main.activeOption"></Color>
        <el-form-item label="堆叠">
          <el-switch v-model="main.activeOption.stack" size="small"></el-switch>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item title="折线设置">
        <el-form-item label="平滑曲线">
          <el-switch v-model="main.activeOption.smooth" size="small">
          </el-switch>
        </el-form-item>
        <el-form-item label="显示右轴线">
          <el-switch v-model="main.activeOption.rightAxisShow" size="small"> </el-switch>
        </el-form-item>
        <el-form-item label="线条宽度">
          <el-slider v-model="main.activeOption.lineWidth">
          </el-slider>
        </el-form-item>
        <el-form-item label="显示标记点">
          <el-switch v-model="main.activeOption.symbolShow" size="small">
          </el-switch>
        </el-form-item>
        <el-form-item label="标记点直径" v-if="main.activeOption.symbolShow">
          <el-slider v-model="main.activeOption.symbolSize">
          </el-slider>
        </el-form-item>
        <el-form-item label="标记点形状" v-if="main.activeOption.symbolShow">
          <el-select v-model="main.activeOption.symbolKind" size="small">
            <el-option v-for="(item, index) in symbolKind" :key="index" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="显示面积">
          <el-switch v-model="main.activeOption.areaStyle" size="small"></el-switch>
        </el-form-item>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import Color from '../../option/components/commonSet/color.vue'
export default {
  name: 'mixBar',
  inject: ["main"],
  components: { Color },
  data() {
    return {
      symbolKind: [{ label: "默认", value: "emptyCircle" }, { label: "圆形", value: "circle" }, { label: "正方形", value: "rect" }, { label: "三角形", value: "triangle" }, { label: "菱形", value: "diamond" }, { label: "别针", value: "pin" }]
    }
  }
}
</script>

<style>
</style>